import { Injectable } from "@angular/core";
import { BehaviorSubject } from 'rxjs';

export interface ToastInfo {
  header: string;
  body: string;
  delay?: number;
  success?: boolean;
}

@Injectable({ providedIn: 'root' })
export class AppToastService {
  toasts: ToastInfo[] = [];
  private success = new BehaviorSubject(false)

  success$  = this.success.asObservable();


  show(header: string, body: string, success?: boolean) {
    this.success.next(success);
    this.toasts.push({ header, body });
  }

  remove(toast: ToastInfo) {
    this.toasts = this.toasts.filter(t => t != toast);
  }
}
